// Pre-bundled translations for the 15 fallback DAY_VIBES_QUESTIONS.
// Keyed by question id → language → { question, options }.
// Options map English source text to translated text so saved answer ids remain stable.
export const VIBE_Q_TRANSLATIONS: Record<string, Partial<Record<string, {
  question: string;
  options: Record<string, string>;
}>>> = {
  "q1": {
    "de": {
      "question": "Wie viel Energie hast du heute?",
      "options": {
        "Full battery. Let’s go.": "Akku voll. Los geht’s.",
        "Halfway, warming up": "Halb voll, komme in Fahrt",
        "Nearly empty, but I’ll show up": "Fast leer, aber ich komme",
        "1%. Do not disturb.": "1 %. Bitte nicht stören."
      }
    },
    "es": {
      "question": "¿Cuánta energía tienes hoy?",
      "options": {
        "Full battery. Let’s go.": "Batería llena. ¡Vamos!",
        "Halfway, warming up": "A medias, cogiendo ritmo",
        "Nearly empty, but I’ll show up": "Casi vacía, pero allí estaré",
        "1%. Do not disturb.": "1 %. No molestar."
      }
    },
    "fr": {
      "question": "T’as combien d’énergie aujourd’hui ?",
      "options": {
        "Full battery. Let’s go.": "Batterie pleine. C’est parti.",
        "Halfway, warming up": "À moitié, je chauffe",
        "Nearly empty, but I’ll show up": "Presque vide, mais je viens",
        "1%. Do not disturb.": "1 %. Ne pas déranger."
      }
    },
    "ru": {
      "question": "Сколько у тебя сегодня энергии?",
      "options": {
        "Full battery. Let’s go.": "Батарейка полная. Погнали.",
        "Halfway, warming up": "Наполовину, разгоняюсь",
        "Nearly empty, but I’ll show up": "Почти на нуле, но приду",
        "1%. Do not disturb.": "1 %. Не беспокоить."
      }
    }
  },
  "q2": {
    "de": {
      "question": "Du kannst dich 20 Minuten lang wegbeamen. Wohin?",
      "options": {
        "A rooftop above the city lights": "Auf ein Dach über den Lichtern der Stadt",
        "A café, headphones on, no small talk": "In ein Café, Kopfhörer auf, kein Smalltalk",
        "Just wandering, no destination": "Einfach losschlendern, ohne Ziel",
        "My sofa. Obviously.": "Auf mein Sofa. Natürlich."
      }
    },
    "es": {
      "question": "Puedes teletransportarte 20 minutos. ¿Adónde?",
      "options": {
        "A rooftop above the city lights": "A una azotea sobre las luces de la ciudad",
        "A café, headphones on, no small talk": "A un café, cascos puestos y sin charla",
        "Just wandering, no destination": "A pasear sin rumbo",
        "My sofa. Obviously.": "A mi sofá. Obviamente."
      }
    },
    "fr": {
      "question": "Tu peux te téléporter 20 minutes. Où ça ?",
      "options": {
        "A rooftop above the city lights": "Sur un toit au-dessus des lumières de la ville",
        "A café, headphones on, no small talk": "Dans un café, casque sur les oreilles, zéro blabla",
        "Just wandering, no destination": "Je me balade, sans destination",
        "My sofa. Obviously.": "Mon canapé. Évidemment."
      }
    },
    "ru": {
      "question": "Можно телепортироваться на 20 минут. Куда?",
      "options": {
        "A rooftop above the city lights": "На крышу над огнями города",
        "A café, headphones on, no small talk": "В кафе: наушники и никаких разговоров",
        "Just wandering, no destination": "Просто бродить без цели",
        "My sofa. Obviously.": "На свой диван. Конечно."
      }
    }
  },
  "q3": {
    "de": {
      "question": "Jemand schreibt: „Lust auf was Spontanes?“ Du antwortest…",
      "options": {
        "Already putting my shoes on": "Zieh schon meine Schuhe an",
        "Define “random” first": "Erst mal: Was heißt „spontan“?",
        "I’ve got a plan, join me instead": "Ich hab schon einen Plan, komm lieber mit",
        "Ask me tomorrow, I’m recharging": "Frag mich morgen, ich lade grad auf"
      }
    },
    "es": {
      "question": "Un amigo escribe: «¿Te apuntas a algo improvisado?». Respondes…",
      "options": {
        "Already putting my shoes on": "Ya me estoy poniendo los zapatos",
        "Define “random” first": "Primero define «improvisado»",
        "I’ve got a plan, join me instead": "Ya tengo plan, vente conmigo",
        "Ask me tomorrow, I’m recharging": "Pregúntame mañana, estoy recargando pilas"
      }
    },
    "fr": {
      "question": "Un pote t’écrit : « Ça te dit, un truc au hasard ? » Tu réponds…",
      "options": {
        "Already putting my shoes on": "Je mets déjà mes chaussures",
        "Define “random” first": "Définis « au hasard » d’abord",
        "I’ve got a plan, join me instead": "J’ai déjà un plan, viens plutôt avec moi",
        "Ask me tomorrow, I’m recharging": "Redemande demain, je recharge"
      }
    },
    "ru": {
      "question": "Друг пишет: «Есть настроение на что-нибудь спонтанное?» Ты отвечаешь…",
      "options": {
        "Already putting my shoes on": "Уже обуваюсь",
        "Define “random” first": "Сначала уточни, что значит «спонтанное»",
        "I’ve got a plan, join me instead": "У меня уже есть план, присоединяйся",
        "Ask me tomorrow, I’m recharging": "Спроси завтра, я на подзарядке"
      }
    }
  },
  "q4": {
    "de": {
      "question": "Treffen mit der Gruppe. Wo landest du?",
      "options": {
        "The quiet corner, watching everyone": "In der ruhigen Ecke, alle beobachten",
        "Deep in a one-on-one chat": "Mitten in einem Gespräch zu zweit",
        "At the loudest, funniest table": "Am lautesten, lustigsten Tisch",
        "Drifting between every table": "Ich wandere von Tisch zu Tisch"
      }
    },
    "es": {
      "question": "Quedada en grupo. ¿Dónde acabas?",
      "options": {
        "The quiet corner, watching everyone": "En el rincón tranquilo, observando",
        "Deep in a one-on-one chat": "En plena charla a dos",
        "At the loudest, funniest table": "En la mesa más ruidosa y divertida",
        "Drifting between every table": "Pasando por todas las mesas"
      }
    },
    "fr": {
      "question": "Soirée entre potes. Tu finis où ?",
      "options": {
        "The quiet corner, watching everyone": "Dans le coin calme, à observer tout le monde",
        "Deep in a one-on-one chat": "En pleine discussion à deux",
        "At the loudest, funniest table": "À la table la plus bruyante et la plus drôle",
        "Drifting between every table": "Je passe de table en table"
      }
    },
    "ru": {
      "question": "Встреча компанией. Где ты в итоге?",
      "options": {
        "The quiet corner, watching everyone": "В тихом углу, наблюдаю за всеми",
        "Deep in a one-on-one chat": "В разговоре один на один",
        "At the loudest, funniest table": "За самым шумным и весёлым столом",
        "Drifting between every table": "Перемещаюсь от стола к столу"
      }
    }
  },
  "q5": {
    "de": {
      "question": "Was läuft gerade in deinem Kopf?",
      "options": {
        "Something slow and a bit dramatic": "Etwas Langsames, leicht Dramatisches",
        "Deep bass that keeps going": "Tiefer Bass, der nicht aufhört",
        "Kitchen-dance pop": "Pop zum Tanzen in der Küche",
        "Nothing. Blissful silence.": "Nichts. Herrliche Stille."
      }
    },
    "es": {
      "question": "¿Qué suena ahora mismo en tu cabeza?",
      "options": {
        "Something slow and a bit dramatic": "Algo lento y un poco dramático",
        "Deep bass that keeps going": "Un bajo profundo que no para",
        "Kitchen-dance pop": "Pop para bailar en la cocina",
        "Nothing. Blissful silence.": "Nada. Un silencio maravilloso."
      }
    },
    "fr": {
      "question": "Qu’est-ce qui passe dans ta tête, là ?",
      "options": {
        "Something slow and a bit dramatic": "Un truc lent et un peu dramatique",
        "Deep bass that keeps going": "Une basse profonde qui ne s’arrête pas",
        "Kitchen-dance pop": "De la pop pour danser dans la cuisine",
        "Nothing. Blissful silence.": "Rien. Un silence divin."
      }
    },
    "ru": {
      "question": "Что сейчас играет у тебя в голове?",
      "options": {
        "Something slow and a bit dramatic": "Что-то медленное и немного драматичное",
        "Deep bass that keeps going": "Глубокий бас без остановки",
        "Kitchen-dance pop": "Поп для танцев на кухне",
        "Nothing. Blissful silence.": "Ничего. Блаженная тишина."
      }
    }
  },
  "q6": {
    "de": {
      "question": "Drei freie Stunden heute. Was passiert wirklich?",
      "options": {
        "I walk somewhere new": "Ich laufe irgendwo hin, wo ich noch nie war",
        "I disappear into a creative project": "Ich verschwinde in einem kreativen Projekt",
        "Good food, good people, no plan": "Gutes Essen, gute Leute, kein Plan",
        "A film or book that swallows the day": "Ein Film oder Buch, das den Tag verschluckt"
      }
    },
    "es": {
      "question": "Tres horas libres hoy. ¿Qué pasa de verdad?",
      "options": {
        "I walk somewhere new": "Camino hasta algún sitio nuevo",
        "I disappear into a creative project": "Me pierdo en un proyecto creativo",
        "Good food, good people, no plan": "Buena comida, buena gente y ningún plan",
        "A film or book that swallows the day": "Una peli o un libro que se come el día"
      }
    },
    "fr": {
      "question": "Trois heures libres aujourd’hui. Il se passe quoi, vraiment ?",
      "options": {
        "I walk somewhere new": "Je pars marcher vers un nouvel endroit",
        "I disappear into a creative project": "Je disparais dans un projet créatif",
        "Good food, good people, no plan": "Bonne bouffe, bonnes personnes, aucun plan",
        "A film or book that swallows the day": "Un film ou un livre qui avale la journée"
      }
    },
    "ru": {
      "question": "Три свободных часа сегодня. Что будет на самом деле?",
      "options": {
        "I walk somewhere new": "Иду гулять в незнакомое место",
        "I disappear into a creative project": "С головой ухожу в творческий проект",
        "Good food, good people, no plan": "Вкусная еда, хорошие люди, никаких планов",
        "A film or book that swallows the day": "Фильм или книга, которые поглощают весь день"
      }
    }
  },
  "q7": {
    "de": {
      "question": "Jemand winkt dir quer durch den Raum zu. Was machst du?",
      "options": {
        "Pretend I didn’t see": "So tun, als hätte ich nichts gesehen",
        "Wave back and hope that’s enough": "Zurückwinken und hoffen, dass das reicht",
        "Already walking over": "Bin schon auf dem Weg rüber",
        "Depends who it is": "Kommt drauf an, wer es ist"
      }
    },
    "es": {
      "question": "Alguien te saluda desde el otro lado de la sala. ¿Qué haces?",
      "options": {
        "Pretend I didn’t see": "Hacer como que no lo he visto",
        "Wave back and hope that’s enough": "Devolver el saludo y esperar que baste",
        "Already walking over": "Ya voy de camino",
        "Depends who it is": "Depende de quién sea"
      }
    },
    "fr": {
      "question": "Quelqu’un te fait signe de l’autre bout de la pièce. Tu fais quoi ?",
      "options": {
        "Pretend I didn’t see": "Faire semblant de ne pas avoir vu",
        "Wave back and hope that’s enough": "Faire signe en retour et espérer que ça suffise",
        "Already walking over": "J’y vais déjà",
        "Depends who it is": "Ça dépend de qui c’est"
      }
    },
    "ru": {
      "question": "Кто-то машет тебе через весь зал. Что делаешь?",
      "options": {
        "Pretend I didn’t see": "Делаю вид, что не вижу",
        "Wave back and hope that’s enough": "Машу в ответ и надеюсь, что этого хватит",
        "Already walking over": "Уже иду навстречу",
        "Depends who it is": "Зависит от того, кто это"
      }
    }
  },
  "q8": {
    "de": {
      "question": "Wenn heute ein Foto wäre – wie sähe es aus?",
      "options": {
        "Dark and cinematic": "Dunkel und filmreif",
        "Warm golden light": "Warmes, goldenes Licht",
        "Neon and electric": "Neon und elektrisierend",
        "Soft and a bit hazy": "Weich und etwas verschwommen"
      }
    },
    "es": {
      "question": "Si hoy fuera una foto, ¿cómo sería?",
      "options": {
        "Dark and cinematic": "Oscura y de película",
        "Warm golden light": "Luz cálida y dorada",
        "Neon and electric": "Neón y eléctrica",
        "Soft and a bit hazy": "Suave y un poco borrosa"
      }
    },
    "fr": {
      "question": "Si aujourd’hui était une photo, elle ressemblerait à quoi ?",
      "options": {
        "Dark and cinematic": "Sombre et cinématographique",
        "Warm golden light": "Une lumière chaude et dorée",
        "Neon and electric": "Néon et électrique",
        "Soft and a bit hazy": "Douce et un peu floue"
      }
    },
    "ru": {
      "question": "Если бы сегодняшний день был фото, каким бы он был?",
      "options": {
        "Dark and cinematic": "Тёмное и кинематографичное",
        "Warm golden light": "Тёплый золотой свет",
        "Neon and electric": "Неон и электричество",
        "Soft and a bit hazy": "Мягкое и немного размытое"
      }
    }
  },
  "q9": {
    "de": {
      "question": "Worauf hast du heute wirklich Lust?",
      "options": {
        "A city walk with no destination": "Ein Stadtspaziergang ohne Ziel",
        "People-watching from a café": "Im Café Leute beobachten",
        "Saying yes to something spontaneous": "Zu etwas Spontanem Ja sagen",
        "Making something with my hands": "Etwas mit meinen Händen machen",
        "Staying home, guilt-free": "Zu Hause bleiben, ohne schlechtes Gewissen"
      }
    },
    "es": {
      "question": "¿Qué te apetece hacer hoy de verdad?",
      "options": {
        "A city walk with no destination": "Un paseo por la ciudad sin rumbo",
        "People-watching from a café": "Mirar a la gente desde un café",
        "Saying yes to something spontaneous": "Decir que sí a algo improvisado",
        "Making something with my hands": "Hacer algo con las manos",
        "Staying home, guilt-free": "Quedarme en casa sin culpa"
      }
    },
    "fr": {
      "question": "T’as vraiment envie de faire quoi aujourd’hui ?",
      "options": {
        "A city walk with no destination": "Une balade en ville sans but",
        "People-watching from a café": "Regarder les gens depuis un café",
        "Saying yes to something spontaneous": "Dire oui à un truc spontané",
        "Making something with my hands": "Fabriquer un truc de mes mains",
        "Staying home, guilt-free": "Rester à la maison, sans culpabiliser"
      }
    },
    "ru": {
      "question": "Чем тебе на самом деле хочется заняться сегодня?",
      "options": {
        "A city walk with no destination": "Прогулка по городу без цели",
        "People-watching from a café": "Наблюдать за людьми из кафе",
        "Saying yes to something spontaneous": "Согласиться на что-то спонтанное",
        "Making something with my hands": "Сделать что-то своими руками",
        "Staying home, guilt-free": "Остаться дома без угрызений совести"
      }
    }
  },
  "q10": {
    "de": {
      "question": "In welchem Tempo läufst du heute?",
      "options": {
        "Slow motion, on purpose": "Zeitlupe, mit Absicht",
        "Steady, one thing at a time": "Gleichmäßig, eins nach dem anderen",
        "Fast and unstoppable": "Schnell und nicht zu bremsen",
        "Sprinting on coffee alone": "Sprint, nur mit Kaffee im Tank"
      }
    },
    "es": {
      "question": "¿A qué velocidad vas hoy?",
      "options": {
        "Slow motion, on purpose": "A cámara lenta, a propósito",
        "Steady, one thing at a time": "Constante, una cosa cada vez",
        "Fast and unstoppable": "Rápido e imparable",
        "Sprinting on coffee alone": "A toda pastilla, solo a base de café"
      }
    },
    "fr": {
      "question": "Tu tournes à quelle vitesse aujourd’hui ?",
      "options": {
        "Slow motion, on purpose": "Au ralenti, exprès",
        "Steady, one thing at a time": "Régulier, une chose à la fois",
        "Fast and unstoppable": "Rapide et inarrêtable",
        "Sprinting on coffee alone": "À fond, carburant : café"
      }
    },
    "ru": {
      "question": "В каком темпе ты сегодня?",
      "options": {
        "Slow motion, on purpose": "Замедленная съёмка, специально",
        "Steady, one thing at a time": "Ровно, по одному делу за раз",
        "Fast and unstoppable": "Быстро и без остановок",
        "Sprinting on coffee alone": "Несусь на одном кофе"
      }
    }
  },
  "q11": {
    "de": {
      "question": "Welche Farbe passt zu heute?",
      "options": {
        "Deep violet": "Tiefes Violett",
        "Warm orange": "Warmes Orange",
        "Electric blue": "Elektrisches Blau",
        "Soft sage green": "Sanftes Salbeigrün"
      }
    },
    "es": {
      "question": "¿Qué color va con el día de hoy?",
      "options": {
        "Deep violet": "Violeta intenso",
        "Warm orange": "Naranja cálido",
        "Electric blue": "Azul eléctrico",
        "Soft sage green": "Verde salvia suave"
      }
    },
    "fr": {
      "question": "Quelle couleur colle à aujourd’hui ?",
      "options": {
        "Deep violet": "Violet profond",
        "Warm orange": "Orange chaud",
        "Electric blue": "Bleu électrique",
        "Soft sage green": "Vert sauge doux"
      }
    },
    "ru": {
      "question": "Какой цвет подходит сегодняшнему дню?",
      "options": {
        "Deep violet": "Глубокий фиолетовый",
        "Warm orange": "Тёплый оранжевый",
        "Electric blue": "Электрический синий",
        "Soft sage green": "Мягкий шалфейный"
      }
    }
  },
  "q12": {
    "de": {
      "question": "Was würde den Tag heute besser machen?",
      "options": {
        "Something calm and grounding": "Etwas Ruhiges, das mich erdet",
        "Something playful and silly": "Etwas Verspieltes und Albernes",
        "A really deep conversation": "Ein richtig tiefes Gespräch",
        "Something exciting and unexpected": "Etwas Aufregendes und Unerwartetes"
      }
    },
    "es": {
      "question": "¿Qué haría mejor el día de hoy?",
      "options": {
        "Something calm and grounding": "Algo tranquilo que me centre",
        "Something playful and silly": "Algo divertido y tonto",
        "A really deep conversation": "Una conversación muy profunda",
        "Something exciting and unexpected": "Algo emocionante e inesperado"
      }
    },
    "fr": {
      "question": "Qu’est-ce qui rendrait ta journée meilleure ?",
      "options": {
        "Something calm and grounding": "Un truc calme qui me recentre",
        "Something playful and silly": "Un truc ludique et idiot",
        "A really deep conversation": "Une conversation vraiment profonde",
        "Something exciting and unexpected": "Un truc excitant et inattendu"
      }
    },
    "ru": {
      "question": "Что сделало бы сегодняшний день лучше?",
      "options": {
        "Something calm and grounding": "Что-то спокойное и заземляющее",
        "Something playful and silly": "Что-то игривое и дурашливое",
        "A really deep conversation": "По-настоящему глубокий разговор",
        "Something exciting and unexpected": "Что-то захватывающее и неожиданное"
      }
    }
  },
  "q13": {
    "de": {
      "question": "Ehrlich: Wie sieht dein Abend aus?",
      "options": {
        "Quiet, early night": "Ruhig, früh ins Bett",
        "Something low-key": "Etwas Entspanntes",
        "Out, if the right plan appears": "Unterwegs, wenn der richtige Plan kommt",
        "Already booked, thanks": "Schon verplant, danke"
      }
    },
    "es": {
      "question": "Sinceramente, ¿cómo pinta esta noche?",
      "options": {
        "Quiet, early night": "Tranquila, a dormir pronto",
        "Something low-key": "Algo tranquilo",
        "Out, if the right plan appears": "Fuera, si sale el plan adecuado",
        "Already booked, thanks": "Ya tengo plan, gracias"
      }
    },
    "fr": {
      "question": "Franchement, ta soirée ressemble à quoi ?",
      "options": {
        "Quiet, early night": "Calme, au lit tôt",
        "Something low-key": "Un truc tranquille",
        "Out, if the right plan appears": "Dehors, si le bon plan arrive",
        "Already booked, thanks": "Déjà pris, merci"
      }
    },
    "ru": {
      "question": "Честно: каким будет сегодняшний вечер?",
      "options": {
        "Quiet, early night": "Тихо и рано спать",
        "Something low-key": "Что-то спокойное",
        "Out, if the right plan appears": "Выйду, если подвернётся хороший план",
        "Already booked, thanks": "Уже всё расписано, спасибо"
      }
    }
  },
  "q14": {
    "de": {
      "question": "Fremde dürfen dich heute ansprechen, wenn sie…",
      "options": {
        "Ask a really interesting question": "Eine richtig interessante Frage stellen",
        "Make me laugh straight away": "Mich sofort zum Lachen bringen",
        "Compliment something oddly specific": "Etwas seltsam Konkretes loben",
        "They don’t. I’m in my own world today.": "Gar nicht. Ich bin heute in meiner eigenen Welt."
      }
    },
    "es": {
      "question": "Un desconocido puede hablarte hoy si…",
      "options": {
        "Ask a really interesting question": "Hace una pregunta muy interesante",
        "Make me laugh straight away": "Me hace reír a la primera",
        "Compliment something oddly specific": "Elogia algo curiosamente concreto",
        "They don’t. I’m in my own world today.": "Mejor no. Hoy estoy en mi mundo."
      }
    },
    "fr": {
      "question": "On peut t’aborder aujourd’hui si on…",
      "options": {
        "Ask a really interesting question": "Pose une question vraiment intéressante",
        "Make me laugh straight away": "Me fait rire direct",
        "Compliment something oddly specific": "Complimente un détail bizarrement précis",
        "They don’t. I’m in my own world today.": "Pas aujourd’hui. Je suis dans ma bulle."
      }
    },
    "ru": {
      "question": "С тобой сегодня можно заговорить, если…",
      "options": {
        "Ask a really interesting question": "Задать по-настоящему интересный вопрос",
        "Make me laugh straight away": "Сразу рассмешить",
        "Compliment something oddly specific": "Похвалить что-то очень конкретное",
        "They don’t. I’m in my own world today.": "Лучше не надо. Я сегодня в своём мире."
      }
    }
  },
  "q15": {
    "de": {
      "question": "Der Abend bekommt einen Plot-Twist. Welchen?",
      "options": {
        "I bump into someone unexpected": "Ich treffe zufällig jemand Unerwartetes",
        "The whole plan changes last minute": "Der ganze Plan ändert sich in letzter Minute",
        "I find a place I never knew existed": "Ich entdecke einen Ort, von dem ich nichts wusste",
        "No twist, please. I’m happy.": "Kein Twist, bitte. Mir geht’s gut."
      }
    },
    "es": {
      "question": "La noche da un giro inesperado. ¿Cuál?",
      "options": {
        "I bump into someone unexpected": "Me encuentro con alguien inesperado",
        "The whole plan changes last minute": "Todo el plan cambia en el último minuto",
        "I find a place I never knew existed": "Descubro un sitio que no sabía que existía",
        "No twist, please. I’m happy.": "Sin giros, por favor. Estoy bien."
      }
    },
    "fr": {
      "question": "Ta soirée prend un tournant inattendu. Lequel ?",
      "options": {
        "I bump into someone unexpected": "Je croise quelqu’un d’inattendu",
        "The whole plan changes last minute": "Tout le plan change à la dernière minute",
        "I find a place I never knew existed": "Je découvre un endroit dont j’ignorais l’existence",
        "No twist, please. I’m happy.": "Pas de rebondissement, merci. Ça me va."
      }
    },
    "ru": {
      "question": "У вечера неожиданный поворот. Какой?",
      "options": {
        "I bump into someone unexpected": "Случайно встречаю неожиданного человека",
        "The whole plan changes last minute": "Весь план меняется в последний момент",
        "I find a place I never knew existed": "Нахожу совершенно незнакомое место",
        "No twist, please. I’m happy.": "Без поворотов, пожалуйста. Мне и так хорошо."
      }
    }
  }
};
